import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';

interface HeaderSearchButtonProps {
    readonly isSearchOpen: boolean;
    readonly isVisible: boolean;
    readonly showButtonLabel: boolean;
    readonly buttonLabel: string;
    readonly onSearchOpen: () => void;
}

export const HeaderSearchButton = (props: HeaderSearchButtonProps) => {
    const getClassNames = (): string => {
        return classNames('HeaderSearchButton', {
            'HeaderSearchButton--Hidden': props.isSearchOpen,
            'HeaderSearchButton--LabelVisible': props.showButtonLabel
        });
    };

    return (
        <button className={getClassNames()} onClick={props.onSearchOpen} tabIndex={props.isVisible ? -1 : undefined}>
            {props.showButtonLabel && <span className="hideOnMobile">{props.buttonLabel}</span>}
            {props.isSearchOpen ? (
                <span>{getTranslation(keys['navigation.close'])}</span>
            ) : (
                <span className="visuallyHidden">{getTranslation(keys['navigation.search'])}</span>
            )}
        </button>
    );
};
